import { c as _c } from "react/compiler-runtime";
import React from "react";
import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { SEOMeta } from "../../../models";
export const SEO: React.FC<SEOMeta> = t0 => {
  const $ = _c(13);
  const {
    title,
    titleTemplate: t1,
    description,
    canonicalurl,
    imageAssetUrl,
    keywords,
    siteName,
    noIndex: t2
  } = t0;
  const titleTemplate = t1 === undefined ? "Gi Effektivt. | %s" : t1;
  const noIndex = t2 === undefined ? false : t2;
  let T0;
  let t3;
  if ($[0] !== canonicalurl || $[1] !== description || $[2] !== imageAssetUrl || $[3] !== keywords || $[4] !== noIndex || $[5] !== siteName || $[6] !== title || $[7] !== titleTemplate) {
    const images = [];
    if (imageAssetUrl) {
      images.push({
        url: imageAssetUrl + "?w=1200&h=630&fit=crop",
        width: 1200,
        height: 630,
        alt: title
      });
    }
    const additionalMetaTags = [];
    if (keywords) {
      additionalMetaTags.push({
        name: "keywords",
        content: keywords
      });
    }
    if (noIndex) {
      additionalMetaTags.push({
        name: "robots",
        content: "noindex, nofollow"
      });
    }
    T0 = Head;
    t3 = generateNextSeo({
      title,
      titleTemplate,
      description,
      canonical: canonicalurl,
      openGraph: {
        url: canonicalurl,
        title,
        description,
        images,
        siteName
      },
      twitter: {
        site: "@gieffektivt",
        cardType: "summary_large_image"
      },
      additionalMetaTags
    });
    $[0] = canonicalurl;
    $[1] = description;
    $[2] = imageAssetUrl;
    $[3] = keywords;
    $[4] = noIndex;
    $[5] = siteName;
    $[6] = title;
    $[7] = titleTemplate;
    $[8] = T0;
    $[9] = t3;
  } else {
    T0 = $[8];
    t3 = $[9];
  }
  let t4;
  if ($[10] !== T0 || $[11] !== t3) {
    t4 = <T0>{t3}</T0>;
    $[10] = T0;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};